export var cilCaretBottom = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M256.286,408.357,16.333,138.548V104H496v36.45ZM56.892,136,256.358,360.287,457.042,136Z' class='ci-primary'/>"];
